module.exports = __webpack_public_path__ + "img/487613-1.899e25fd.png";